import { BaseBloc } from '@core/utils/bloc';
import { CompactDealStageResponse, DealBoardId, DealStageId, DealStageResponse } from '@business/entities/deal';
import { Repository } from '@core/utils/repository';
import { DealAPI } from '@business/api/deal';
import { handleMessage, requestMessage } from '@business/messages';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class DealStageBloc extends BaseBloc {
  private readonly dealStageRepo = new Repository<CompactDealStageResponse | DealStageResponse>({
    getItemId: item => item.id,
  });

  readonly stages$ = this.dealStageRepo.items$;
  readonly selectStage = this.dealStageRepo.selectItem;

  onReset() {
    this.dealStageRepo.reset();
  }

  fetchDealStages = () => {
    return DealAPI.fetchDealStages().pipe(this.dealStageRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_pros_error') }));
  };

  //   fetchDealStage = (id: string) => {
  //     return DealAPI.fetchDealStage(id).pipe(
  //       this.dealStageRepo.ops.upsertOne(item => ({ item })),
  //       handleMessage({ error: requestMessage('fetch_deal_stage_error') }),
  //     );
  //   };

  createDealStage = (boardId: DealBoardId, title: string, description: string) => {
    return DealAPI.createDealStage(boardId, title, description).pipe(
      this.dealStageRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_deal_stage'),
      }),
    );
  };

  updateDealStage = (id: DealStageId, title: string, boardId: DealBoardId, description: string) => {
    return DealAPI.updateDealStage(id, title, boardId, description).pipe(
      this.dealStageRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_deal_stage'),
      }),
    );
  };

  deleteDealStage = (id: DealStageId) => {
    return showDeleteConfirmation('Delete Deal Stage', 'Do you really want to remove this deal stage?').pipe(
      switchMap(() => DealAPI.deleteDealStage(id)),
      this.dealStageRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_deal_stage'),
      }),
    );
  };
}
